import Validators from '../validators'

export default (store) => store.createEmbededEntityState({
  attrs: ['film_slug'],
  noSort: ['film_slug'],
  titles: [store.__('film slug')],
  _sortField: 'film_slug',
  validators: {
    film_slug: Validators.isMandatory(store),
    '_global': (vals, items) => {}
  }
})
